export const intitial_production_eth_id =  67;